import { z } from 'zod';
export const HealthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    db: z.enum(['ok', 'error']),
    uptime_seconds: z.number(),
    instance_env: z.enum(['development', 'staging', 'production']),
    version: z.string(),
    timestamp: z.string(),
});
//# sourceMappingURL=health.js.map